import {
    FETCH_TEMPLATE_REQUEST,
    FETCH_TEMPLATE_SUCCESS,
    FETCH_TEMPLATE_FAILURE,
    
  } from "../actions/project.js";
  
  export default function project(state = {
    isFetching: false,
    errorMessage: '',
    projectData:[]
  }, action) {
    switch (action.type) {
      case FETCH_TEMPLATE_REQUEST:
        return Object.assign({}, state, {
          isFetching: true,
        });
      case FETCH_TEMPLATE_SUCCESS:
        return Object.assign({}, state, {
          isFetching: false,
          errorMessage: '',
          projectData: action.payload
        });
      case FETCH_TEMPLATE_FAILURE:
        return Object.assign({}, state, {
          isFetching: false,
          errorMessage: action.payload,
        });

     
      default:
        return state;
    }
  }